export default __webpack_public_path__ + "static/media/kafka-logo.132b2d82.png";